module.exports = __webpack_public_path__ + "static/media/Karmilla-Bold.7933882cea4aff448efb7a444c70d1ca.woff";